import type {RepositoryDataResponse} from '@github-ui/data-router-error-helpers'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import {RepositoryMilestoneEditPageQuery} from '@github-ui/server-persisted-queries'
import type {RepositoryMilestoneEditPageQueryQuery} from '@github-ui/server-persisted-queries/types/RepositoryMilestoneEditPageQuery'

import {repoAppBuilder} from '@github-ui/repo-app-builder'

// need this type to expose the errors array so we can detect FORBIDDEN
export type MilestoneEditPayload = RepositoryDataResponse<RepositoryMilestoneEditPageQueryQuery>

export function buildMilestoneEditRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('milestoneEditRoute', {
    path: '/:owner/:repo/milestones/:number/edit',
    queries: [
      mainQuery<MilestoneEditPayload>({
        // owner/name/number are resolved from the pathname by the BFF, so we only
        // need to forward the pathname and the persisted-query id.
        queryDeps: ({pathname}) => ({
          pathname,
          searchParams: {
            queryId: RepositoryMilestoneEditPageQuery,
          },
        }),
      }),
    ],
  })
}

export const milestoneEditRoute = buildMilestoneEditRoute(repoAppBuilder)
